/**
 * Tenant policy shape returned by GET /api/v1/buntu/runtime.
 * Mirrors app.services.buntu.defaults.DEFAULT_CONFIG.
 */

export interface BuntuTenantPolicy {
  enablement: {
    enabled: boolean;
    platforms: string[];
    allow_user_opt_out: boolean;
    required_for_admins?: boolean;
  };
  presence: {
    default_corner: 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left';
    idle_floating_head: boolean;
    cursor_watching: boolean;
    drag_and_drop_return: boolean;
    click_expressions: boolean;
    respect_reduced_motion: boolean;
  };
  wellness: {
    enabled: boolean;
    interval_minutes: number;
    message_pack: string[];
    quiet_hours_enabled: boolean;
    quiet_hours_start: string;
    quiet_hours_end: string;
    pause_when_idle: boolean;
  };
  messaging: {
    enabled: boolean;
  };
  branding: {
    companion_name: string;
    welcome_line: string;
    bubble_accent: string;
    messaging_only: boolean;
  };
  privacy: {
    cosmetic_notice: boolean;
    no_surveillance: boolean;
    allow_minimize: boolean;
    dnd_enabled: boolean;
    dnd_start: string;
    dnd_end: string;
  };
}

export interface AdminMessage {
  id: string;
  body: string;
  priority: string;
  delivery: string;
  /** Hub username / admin who broadcast the message. */
  created_by?: string | null;
  /** ISO timestamp when the message was sent. */
  sent_at?: string | null;
}

/** HH:MM local time inside [start, end), supporting overnight windows. */
export function inTimeWindow(start: string, end: string, now = new Date()): boolean {
  const toMin = (s: string) => {
    const [h, m] = (s || '00:00').split(':').map((x) => parseInt(x, 10) || 0);
    return h * 60 + m;
  };
  const cur = now.getHours() * 60 + now.getMinutes();
  const a = toMin(start);
  const b = toMin(end);
  if (a === b) return false;
  if (a < b) return cur >= a && cur < b;
  return cur >= a || cur < b;
}
